import { Avatar, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import React, { useEffect, useState } from "react";
import { filterOptions } from "../DataProvider/DataProvider";
import aderantTheme from "../Theme/AderantTheme";
import "./DataProviderList.css";
const palette = aderantTheme.palette;
// Default props
DataProviderList.defaultProps = {
    disabled: false
};
/** Lookup List component for Data Providers - this component has no input box */
export function DataProviderList(props) {
    const { inputValue, dataProvider, onSelected, sx, id } = props;
    //All options is initial full list of items to display in the list
    const [allOptions, setAllOptions] = useState([]);
    //Options is the filtered list of items to display in the list
    const [options, setOptions] = useState([]);
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [searchTerm, setSearchTerm] = useState(""); // the term we end up querying against
    //Get all options from the data provider
    useEffect(() => {
        const getAllOptions = () => {
            dataProvider
                ? dataProvider
                    .queryAllItems()
                    .then((response) => {
                    setAllOptions(response?.items ?? []);
                })
                    .catch((error) => {
                    console.error("Error getting all options from dataProvider:", error);
                    setAllOptions([]);
                })
                : setAllOptions([]);
        };
        getAllOptions();
    }, [dataProvider]);
    //Set the searchTerm to filter the options based on the input value
    useEffect(() => {
        if (!inputValue) {
            setSearchTerm("");
        }
        else {
            setSearchTerm(inputValue);
        }
    }, [inputValue]);
    //Filter the options when the searchTerm changes
    useEffect(() => {
        if (!searchTerm) {
            setOptions(allOptions);
        }
        else {
            setOptions(filterOptions(allOptions, { inputValue: searchTerm }));
        }
    }, [searchTerm, allOptions]);
    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
        onSelected && onSelected(event, options[index]);
    };
    return (React.createElement(List, { id: id ? `${id}-dp-select-list` : "dp-select-list", "aria-label": props["aria-label"], dense: true, sx: { backgroundColor: palette.background.default, ...sx?.list } }, options.map((option, index) => renderRow({ index: index, sx: sx?.listItem, data: option }))));
    function renderRow(props) {
        const { index, sx, data } = props;
        if (data) {
            return (React.createElement(ListItemButton, { key: index, selected: selectedIndex === 0, onClick: (event) => handleListItemClick(event, index) },
                React.createElement(ListItem, { key: data.id, id: data.id.toString(), sx: sx },
                    React.createElement(ListItemAvatar, null,
                        React.createElement(Avatar, null)),
                    React.createElement(ListItemText, { primary: data.primaryText, secondary: data.secondaryText ? data.secondaryText : null }))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    }
}
